import React from 'react';
import get from 'lodash/get';
import * as StyledComponents from '../StyledComponents';
import { PrimaryButton, IconSchedule, DatePicker, Checkbox, BUTTON_SIZES, RadioGroup} from 'cdk-radial';
import { useUnifyAdminStore } from '../../AdminStore';
import { TimeField } from '../Elements/TimeField';
import './notification.css';
import { MultiSelectDropdownMenu } from '../Elements/MultiSelectDropdownMenu';
import find from 'lodash/find';

import { createFeatureModel, translationModel } from '../Store/modelTransformation';
import {useCreateQuery,useUpdateQuery, useTranslator} from '../Store/useReleaseNotificationQuery';

import styled from 'styled-components';
import { useTheme } from 'styled-components';
import moment from 'moment';
import {useAllApplicationsStore, useAllWorkflowsStore,} from '../../../../Store/index'
import CustomEditor from './CustomEditor';
import { CustomMultiTargetEditor } from './CustomMultiTargetEditor';
import {BrowseOrDragBulkUpload} from './BrowseOrDragBulkUpload';
import { getLocalizationValues } from '../../utils';
import { useUserProfile } from '../../../../hooks/queries';
import { useTranslation } from 'react-i18next';

interface TabItem {
  id: string;
  panelId: string;
  renderPanel: any;
  renderTab: any;
}

type Positions = {
  top: string;
  bottom: string;
  left: string;
  right: string;
};

type ActionButtonsContainer = {
  children: React.ReactNode;
  position?: string;
  positionProps?: Partial<Positions>;
  background?: string;
  zIndex?: string
};

const ActionButtonContainer = ({
  children,
  zIndex,
  position,
  positionProps,
  background,
}: ActionButtonsContainer): JSX.Element => {
  return (
    <StyledComponents.StyledActionButtonContainer
      positionProps={positionProps}
      position={position}
      background={background}
      zIndex={zIndex}
    >
      {children}
    </StyledComponents.StyledActionButtonContainer>
  );
};

/*
function validateURL(url: string) {
  if (
    //eslint-disable-next-line
    /^(http[s]?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/g.test(
      url
    )
  ) {
    return true;
  } else {
    return false;
  }
}*/

export const StyledWrapperDatePicker = styled.div<{
  maxWidth: string;
  dayPickerLeft: string;
}>`
  max-width: ${(props) => props.maxWidth || '150px'};
  .DayPicker {
    left: ${(props) => props.dayPickerLeft || 'unset'};
    bottom: 0;
    margin-bottom: 55px;
    top: auto;
    z-index:1000;
  }
`;

const applicationToOptions = (data: any) => {
  if (data && data[0]) {
    const applications = data[0];
    if (applications) {
      const filteredApps = applications.filter(
        (app: any) =>
          app.name !== 'Fortellis Marketplace Operations' &&
          app.name !== 'CDK University' &&
          app.name !== 'Customer Care' &&
          app.name !== 'Unify Administration' &&
          app.name !== 'CDK Resource Center'
      );
      let options = filteredApps.map((application: any) => {
        return {
          id: application.appId,
          label: application.name,
          value: application.appId,
        };
      });
      return options;
    }
  }
};

interface Option {
  id: string;
  label: string;
  value: string;
}

const filterWorkflowOptions = (applications: any, workflowsData: any) => {
  let filtered = [] as Option[];
  if (workflowsData) {
    const workflows = workflowsData[0];
    if (workflows) {
      workflows.forEach((workflow: any) => {
        if (
          workflow.applications &&
          workflow.applications[0] &&
          workflow.applications[0].appId
        ) {
          const applId = workflow.applications[0].appId;
          const found = find(applications, (app: any) => app.id === applId);
          if (found) {
            filtered.push({
              id: workflow.workflowId,
              label: workflow.name,
              value: workflow.workflowId,
            });
          }
        }
      });
    }
  }
  return filtered;
};

export const FeatureReleaseSheetDetails = (): JSX.Element => {
  const { t } = useTranslation();
  const { darkMode } = useTheme();
  const {data: userProfile} = useUserProfile();
  const departmentOptions = useUnifyAdminStore((state) => state.departmentList);

  const sideSheetData = useUnifyAdminStore(
    (state) => state.releaseSideSheetData
  );


  const showFrenchTranslation = useUnifyAdminStore((state) => state.showFrenchNotificationContent)
  const setShowFrenchTranslation = useUnifyAdminStore((state) => state.setShowFrenchNotificationContent)
  const showCanadaEnglishTranslation = useUnifyAdminStore((state) => state.showCanadaEnglishNotificationContent)
  const setShowCanadaEnglishTranslation = useUnifyAdminStore((state) => state.setShowCanadaEnglishNotificationContent)
  const showStartDateValidation = useUnifyAdminStore((state) => state.showStartDateValidation);
  const setShowStartDateValidation = useUnifyAdminStore((state) => state.setShowStartDateValidation);
  const showEndDateValidation = useUnifyAdminStore((state) => state.showEndDateValidation);
  const setShowEndDateValidation = useUnifyAdminStore((state) => state.setShowEndDateValidation);

  const {mutation:createMutation} = useCreateQuery({
    onSuccess: () => {
      setReleaseShowToastState(t('featureRelease.toastCreateSuccess', { title: getLocalizationValues(userProfile, sideSheetData).title }), 'Success');
      closeSideSheet()
    },
    onError: () => {
      setReleaseShowToastState(t('featureRelease.toastCreateError'), 'Error');
      closeSideSheet()
    }
  });

  const { mutation: translateMutation } = useTranslator();

  const {mutation:updateMutation} = useUpdateQuery({
    onSuccess: () => {
      setReleaseShowToastState(t('featureRelease.toastUpdateSuccess', { title: getLocalizationValues(userProfile, sideSheetData).title }), 'Success');
      closeSideSheet()
    },
    onError: () => {
      setReleaseShowToastState(t('featureRelease.toastUpdateError'), 'Error');
      closeSideSheet()
    }
  });

  const setWorkflowSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setAdminSideSheetCollapse
  );
  const setApplicationSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setWorkflowSideSheetCollapse
  );
  const setProductOutageSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setProductOutageSideSheetCollapse
  );
  const setReleaseSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setReleaseSideSheetCollapse
  );
  const resetReleaseSideSheetState = useUnifyAdminStore(
    (state) => state.resetReleaseSideSheetState
  );
  const archiveSwitch = useUnifyAdminStore((state) => state.releaseArchiveSwitch);

  const applications = useAllApplicationsStore((state:any) => state.applications);
  const workflows = useAllWorkflowsStore((state:any) => state.workflows);

  const applicationOptions = applicationToOptions(applications);
  const workflowOptions = filterWorkflowOptions(
    get(sideSheetData, 'targetApplications', []),
    workflows
  );

  const updateReleaseSideSheetData = useUnifyAdminStore(
    (state) => state.updateReleaseSideSheetData
  );
  const setReleaseShowToastState = useUnifyAdminStore(
    (state) => state.setReleaseShowToastState
  );
  const setIsValidationState = useUnifyAdminStore(
    (state) => state.setIsReleaseValidationState
  );
  const onApplicationSelect = (applications: any) => {
    updateReleaseSideSheetData({
      fieldName: 'targetApplications',
      value: applications,
    });
    const workflowOptions = filterWorkflowOptions(applications, workflows);

    //For removing selected workflows when their application deselect
    const selectedWorkflows = { ...sideSheetData.targetWorkflows };
    const updatedSelectedWorkflows = Object.values(selectedWorkflows).filter(
      (selectedWorkflow: any) =>
        workflowOptions.some(
          (workflowOption: any) =>
            workflowOption.id === selectedWorkflow.id
        )
    );
    updateReleaseSideSheetData({
      fieldName: 'targetWorkflows',
      value: updatedSelectedWorkflows,
    });
  };
  const onWorkflowSelect = (applications: any) => {
    updateReleaseSideSheetData({
      fieldName: 'targetWorkflows',
      value: applications,
    });
  };

  const onDepartmentSelect = (departments: any) => {
    updateReleaseSideSheetData({
      fieldName: 'targetDepartments',
      value: departments,
    });
  };

  const onStartDateChange = (startDate: any) => {
    updateReleaseSideSheetData({
      fieldName: 'startDate',
      value: startDate,
    });
  };
  const onEndDateChange = (endDate: any) => {
    updateReleaseSideSheetData({ fieldName: 'endDate', value: endDate });
  };
  const onStartTimeChange = (startTime: any) => {
    updateReleaseSideSheetData({
      fieldName: 'startTime',
      value: startTime,
    });
  };
  const onEndTimeChange = (endTime: any) => {
    updateReleaseSideSheetData({ fieldName: 'endTime', value: endTime });
  };

  const includeExcludeTargets = (e: any) => {

    const includeFlag = e.target.value;

    updateReleaseSideSheetData({
      fieldName: 'includeTargets', value: includeFlag === "include"
    });

  }

  const descriptionBodyLocale = get(sideSheetData, 'bodyLocale');
  const titleLocale = get(sideSheetData, 'titleLocale');
  const subjectLocale = get(sideSheetData, 'subjectLocale');
  const linkToLearnMoreLocale = get(sideSheetData, 'linkToLearnMoreLocale');

  const onShortDescChange = (key: any = "enUS") => {

    const targetName = (key.target.name).includes("enUS") ? "enUS" : ((key.target.name).includes("enCA") ? "enCA" : "frCA");

    const inputEleVal = key.target.value;

    if (targetName === "enUS") {
      updateReleaseSideSheetData({
        fieldName: 'subject',
        value: inputEleVal
      });
    } else {

      updateReleaseSideSheetData({
        fieldName: 'subjectLocale',
        value: { enCA: (targetName === "enCA") ? inputEleVal : subjectLocale?.enCA, frCA: (targetName === "frCA") ? inputEleVal : subjectLocale?.frCA }
      });
    }
  };

  const onTitleChange = (key: any = "enUS") => {

    const targetName = (key.target.name).includes("enUS") ? "enUS" : ((key.target.name).includes("enCA") ? "enCA" : "frCA");

    const inputEleVal = key.target.value;

    if (targetName === "enUS") {
      updateReleaseSideSheetData({
        fieldName: 'title',
        value: inputEleVal
      });
    } else {

      updateReleaseSideSheetData({
        fieldName: 'titleLocale',
        value: { enCA: (targetName === "enCA") ? inputEleVal : titleLocale?.enCA, frCA: (targetName === "frCA") ? inputEleVal : titleLocale?.frCA }
      });
    }
  };

  const onLongDescChangeenUS = (e: any) => {
    updateReleaseSideSheetData({
      fieldName: 'body',
      value: e.target.value,
    });
  };

  const onLongDescChangefrCA = (e: any) => {
    updateReleaseSideSheetData({
      fieldName: 'bodyLocale',
      value: {frCA: e.target.value, enCA: descriptionBodyLocale?.enCA},
    });
  };

  const onLongDescChangeenCA= (e: any) => {
    updateReleaseSideSheetData({
      fieldName: 'bodyLocale',
      value: {frCA: descriptionBodyLocale?.frCA, enCA: e.target.value},
    });
  };

  const onLearnMoreChange = (key: any = "enUS") => {

    const targetName = (key.target.name).includes("enUS") ? "enUS" : ((key.target.name).includes("enCA") ? "enCA" : "frCA");

    const inputEleVal = key.target.value;

    if (targetName === "enUS") {
      updateReleaseSideSheetData({
        fieldName: 'linkToLearnMore',
        value: inputEleVal
      });
    } else {

      updateReleaseSideSheetData({
        fieldName: 'linkToLearnMoreLocale',
        value: { enCA: (targetName === "enCA") ? inputEleVal : linkToLearnMoreLocale?.enCA, frCA: (targetName === "frCA") ? inputEleVal : linkToLearnMoreLocale?.frCA }
      });
    }
  };

  const closeSideSheet = () => {
    setWorkflowSideSheetCollapse(true);
    setApplicationSideSheetCollapse(true);
    setReleaseSideSheetCollapse(true);
    setProductOutageSideSheetCollapse(true);
    resetReleaseSideSheetState();
  };

  const handleUpdate = () =>{
    if (!handleValidation()) return;
    const model = [];
    model.push({messageId:sideSheetData.messageId});
    model.push(createFeatureModel(sideSheetData, userProfile, "update"));
    updateMutation.mutate(model);
  }

  const handleSave = () => {
    if (!handleValidation()) return;
    createMutation.mutate(createFeatureModel(sideSheetData, userProfile));
  };

  const handleCancel = () => {
    closeSideSheet();
  };

  const handleTranslate = (lang: string) => {
    translateMutation.mutate(translationModel(sideSheetData, lang), {
      onSuccess: (translated) => {
        if (translated) {
          updateReleaseSideSheetData({
            fieldName: 'titleLocale',
            value: {
              ...sideSheetData.titleLocale,
              [lang]: translated.title,
            },
          });

          updateReleaseSideSheetData({
            fieldName: 'subjectLocale',
            value: {
              ...sideSheetData.subjectLocale,
              [lang]: translated.subject,
            },
          });

          updateReleaseSideSheetData({
            fieldName: 'bodyLocale',
            value: {
              ...sideSheetData.bodyLocale,
              [lang]: translated.body,
            },
          });
        }
        setReleaseShowToastState(t('featureRelease.toastTranslateSuccess'), 'Success');
      },
      onError: () => {
        setReleaseShowToastState(t('featureRelease.toastTranslateError'), 'Error');
      },
    });
  };

  const hasContent = (html: string) => !!html?.replace(/<[^>]*>/g, '').trim();

  const handleValidation = () => {
    if (!sideSheetData.title) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidTitle'), 'Error');
      return false;
    }
    if (!sideSheetData.subject) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidDescription'), 'Error');
      return false;
    }
    if (!sideSheetData.body) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidDetailedDesc'), 'Error');
      return false;
    }

    const isValid =
      sideSheetData?.targetEnterprises
        ?.split(',')
        .map((enterprise) => enterprise.trim())
        .every(
          (enterprise) => /^E\d{6}$/.test(enterprise) || enterprise === ''
        ) ?? true;
      const isCNumberValid =
      sideSheetData?.targetCNumbers
        ?.split(',')
        .map((cnumber) => cnumber.trim())
        .every(
          (cnumber) => /^C\d{6}$/.test(cnumber) || cnumber === ''
        ) ?? true;
        const isStoreValid =
      sideSheetData?.targetStores
        ?.split(',')
        .map((store) => store.trim())
        .every(
          (store) => /^S\d{9}$/.test(store) || store === ''
        ) ?? true;
    if (sideSheetData?.targetEnterprises && !isValid) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidEnterprise'), 'Error');
      return false;
    }
    if (sideSheetData?.targetCNumbers && !isCNumberValid) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidCNumber'), 'Error');
      return false;
    }
    if (sideSheetData?.targetStores && !isStoreValid) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidStore'), 'Error');
      return false;
    }
    const timeRegex = /^(0?[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

    if (!sideSheetData.startDate) {
      setIsValidationState(true);
      setShowStartDateValidation(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidStartDate'), 'Error');
      return false;
    }

    if (!sideSheetData.startTime || !timeRegex.test(sideSheetData.startTime)) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidStartTime'), 'Error');
      return false;
    }

    if (!sideSheetData.endDate) {
      setIsValidationState(true);
      setShowEndDateValidation(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidEndDate'), 'Error');
      return false;
    }

    if (!sideSheetData.endTime || !timeRegex.test(sideSheetData.endTime)) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastInvalidEndTime'), 'Error');
      return false;
    }

    const startDateV = moment(
      sideSheetData.startDate.format('MM/DD/YYYY') +
        'T' +
        sideSheetData.startTime,
      'MM/DD/YYYY hh:mm ZZ'
    );

    const endDateV = moment(
      sideSheetData.endDate.format('MM/DD/YYYY') + 'T' + sideSheetData.endTime,
      'MM/DD/YYYY hh:mm ZZ'
    );

    if(!sideSheetData.messageId){
      if (moment(new Date()).isAfter(startDateV)) {
        setIsValidationState(true);
        setReleaseShowToastState(t('featureRelease.toastStartDateFuture'), 'Error');
        return false;
      }
    }

    if (startDateV.isAfter(endDateV)) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastEndDateAfterStart'), 'Error');
      return false;
    }

    const now = moment();
    if (endDateV.isBefore(now)) {
      setIsValidationState(true);
      setReleaseShowToastState(t('featureRelease.toastEndTimeFuture'), 'Error');
      return false;
    }

    /*if (
      sideSheetData?.linkToLearnMore &&
      !validateURL(sideSheetData?.linkToLearnMore)
    ) {
      setIsValidationState(true);
      setReleaseShowToastState('Please enter a valid learn more link', 'Error');
      return false;
    }*/

    return true;
  };

  const [activeItemIndex, setActiveItemIndex] = React.useState(0);

  let tabs: TabItem[] = [];

  tabs.push({
    id: 'tab-1',
    panelId: 'panel-1',
    renderPanel: (props: any) => (
      <StyledComponents.StyledTabPanel {...props}>
        <CustomMultiTargetEditor readOnlyMode={archiveSwitch}/>
      </StyledComponents.StyledTabPanel>
    ),
    renderTab: (props: any) => (
      <StyledComponents.StyledTab
        label={t('featureRelease.enterTargets')}
        {...props}
      />
    ),
  });

  tabs.push({
    id: 'tab-2',
    panelId: 'panel-2',
    renderPanel: (props: any) => (
      <StyledComponents.StyledTabPanel {...props}>
        <BrowseOrDragBulkUpload />
      </StyledComponents.StyledTabPanel>
    ),
    renderTab: (props: any) => (
      <StyledComponents.StyledTab
        label={t('featureRelease.bulkUploadTargets')}
        {...props}
      />
    ),
  });

  return (
    <div style={{ padding: '10px' }}>
      <>
        <Checkbox
          style={{ width: '245px', paddingRight: '0.5rem' }}
          checked={showCanadaEnglishTranslation}
          dataTestId="show-canada-english-checkbox"
          id="notificationRelCa"
          label={t('featureRelease.showCanadaEnglish')}
          labelPosition="after"
          name="canadaEnglishShowRel"
          onChange={() => setShowCanadaEnglishTranslation(!showCanadaEnglishTranslation)}
          size="standard"
        />
        {
          showCanadaEnglishTranslation && sideSheetData.title && sideSheetData.subject && hasContent(sideSheetData.body) && (
            <PrimaryButton
              dataTestId="ca-translate-button"
              size={BUTTON_SIZES.SMALL}
              iconColor="primary"
              onClick={() => handleTranslate("enCA")}
              text={t('featureRelease.translate')}
              isDisabled={archiveSwitch || createMutation.isLoading}
            />
          )}
      </>
      <>
        <Checkbox
          style={{ width: '245px', paddingRight: '0.5rem' }}
          checked={showFrenchTranslation}
          dataTestId="show-french-checkbox"
          id="notificationRelFr"
          label={t('featureRelease.showCanadaFrench')}
          labelPosition="after"
          name="frenchShowRel"
          onChange={() => setShowFrenchTranslation(!showFrenchTranslation)}
          size="standard"
        />
        {
          showFrenchTranslation && sideSheetData.title && sideSheetData.subject && hasContent(sideSheetData.body) && (
            <PrimaryButton
              dataTestId="ca-translate-button"
              size={BUTTON_SIZES.SMALL}
              iconColor="primary"
              onClick={() => handleTranslate("frCA")}
              text={t('featureRelease.translate')}
              isDisabled={archiveSwitch || createMutation.isLoading}
            />
          )}
      </>
      <StyledComponents.StyledInput
        dataTestId={`title-input`}
        errorMessage={t('featureRelease.fieldErrorTitle')}
        id={`title-name-input-enUS`}
        inputDivider="left"
        label={t('featureRelease.titleLabel')}
        name={'title-enUS'}
        onChange={(e: any) => onTitleChange(e)}
        placeholder={t('featureRelease.titlePlaceholder')}
        value={get(sideSheetData, 'title', '')}
        hasCharacterCount={true}
        maxLength={100}
        isRequired={true}
        isDisabled={archiveSwitch}
      />
      <StyledComponents.StyledInput
        dataTestId={`short-desc-input`}
        errorMessage={t('featureRelease.fieldErrorDescription')}
        id={`short-desc-name-input-enUS`}
        inputDivider="left"
        label={t('featureRelease.shortDescLabel')}
        name="subject-enUS"
        placeholder={t('featureRelease.shortDescPlaceholder')}
        onChange={(e: any) => onShortDescChange(e)}
        value={get(sideSheetData, 'subject', '')}
        hasCharacterCount={true}
        maxLength={150}
        isRequired={true}
        isDisabled={archiveSwitch}
      />
      <div style={{ marginTop: '10px' }}>
        <StyledComponents.StyledCustomEditorLabel>{t('featureRelease.detailedDescription')}</StyledComponents.StyledCustomEditorLabel>
        <CustomEditor
          value={get(sideSheetData, 'body', '')}
          onChange={onLongDescChangeenUS} readOnlyMode={archiveSwitch}>
        </CustomEditor>
        <StyledComponents.StyledLongDescCount>
          <StyledComponents.StyledCountLabel>
            {get(sideSheetData, 'body', '').length}/4750
          </StyledComponents.StyledCountLabel>
        </StyledComponents.StyledLongDescCount>
      </div>
      {showCanadaEnglishTranslation &&
        <StyledComponents.StyledCustomEditorLabel>{t('featureRelease.canadaEnglish')}</StyledComponents.StyledCustomEditorLabel>
      }
      {showCanadaEnglishTranslation &&
        <StyledComponents.StyledInput
          dataTestId={`title-input-enca`}
          errorMessage={t('featureRelease.fieldErrorTitle')}
          id={`title-name-input-enCA`}
          inputDivider="left"
          label={t('featureRelease.canadaEnglishTitle')}
          name={'title-enCA'}
          onChange={(e: any) => onTitleChange(e)}
          placeholder={t('featureRelease.canadaEnglishTitlePlaceholder')}
          value={get(sideSheetData, 'titleLocale.enCA', '')}
          hasCharacterCount={true}
          maxLength={100}
          isRequired={false}
          isDisabled={archiveSwitch}
        />}
        {showCanadaEnglishTranslation &&
        <StyledComponents.StyledInput
          dataTestId={`short-desc-input`}
          errorMessage={t('featureRelease.fieldErrorDescription')}
          id={`short-desc-name-input-enCA`}
          inputDivider="left"
          label={t('featureRelease.canadaEnglishShortDesc')}
          name="subject-enCA"
          placeholder={t('featureRelease.canadaEnglishShortDescPlaceholder')}
          onChange={(e: any) => onShortDescChange(e)}
          value={get(sideSheetData, 'subjectLocale.enCA', '')}
          hasCharacterCount={true}
          maxLength={150}
          isRequired={false}
          isDisabled={archiveSwitch}
        />}
        {showCanadaEnglishTranslation && <>
        <div style={{ marginTop: '10px' }}>
          <StyledComponents.StyledCustomEditorLabel>{t('featureRelease.canadaEnglishDetailedDesc')}</StyledComponents.StyledCustomEditorLabel>
          <CustomEditor
            value={get(sideSheetData, 'bodyLocale.enCA', '')}
            onChange={onLongDescChangeenCA} readOnlyMode={archiveSwitch}>
          </CustomEditor>
          <StyledComponents.StyledLongDescCount>
            <StyledComponents.StyledCountLabel>
              {get(sideSheetData, 'bodyLocale.enCA', '').length}/4750
            </StyledComponents.StyledCountLabel>
          </StyledComponents.StyledLongDescCount>
        </div>
        <div style={{ marginTop: '10px' }}>
        <StyledComponents.StyledTextAreaWithCustomHeight
          customHeight="60px"
          dataTestId={`learn-more-input-enCA`}
          errorMessage="Error message"
          id={`learn-more-name-input-enCA`}
          inputDivider="left"
          label={t('featureRelease.learnMoreEnCA')}
          name="learnMore-enCA"
          onChange={onLearnMoreChange}
          placeholder={`Eg. https://connectcdk.com/`}
          value={get(sideSheetData, 'linkToLearnMoreLocale.enCA', '')}
          maxLength={200}
          isDisabled={archiveSwitch}
        />
      </div></>}
      {showFrenchTranslation &&
        <StyledComponents.StyledCustomEditorLabel>{t('featureRelease.canadaFrench')}</StyledComponents.StyledCustomEditorLabel>
      }
      {showFrenchTranslation &&
        <StyledComponents.StyledInput
          dataTestId={`title-input-frca`}
          errorMessage={t('featureRelease.fieldErrorTitle')}
          id={`title-name-input-frCA`}
          inputDivider="left"
          label={t('featureRelease.frenchTitle')}
          name={'title-frCA'}
          onChange={(e: any) => onTitleChange(e)}
          placeholder={t('featureRelease.frenchTitlePlaceholder')}
          value={get(sideSheetData, 'titleLocale.frCA', '')}
          hasCharacterCount={true}
          maxLength={100}
          isRequired={false}
          isDisabled={archiveSwitch}
        />}
      {showFrenchTranslation &&
        <StyledComponents.StyledInput
          dataTestId={`short-desc-input`}
          errorMessage={t('featureRelease.fieldErrorDescription')}
          id={`short-desc-name-input-frCA`}
          inputDivider="left"
          label={t('featureRelease.frenchShortDesc')}
          name="subject-frCA"
          placeholder={t('featureRelease.frenchShortDescPlaceholder')}
          onChange={(e: any) => onShortDescChange(e)}
          value={get(sideSheetData, 'subjectLocale.frCA', '')}
          hasCharacterCount={true}
          maxLength={150}
          isRequired={false}
          isDisabled={archiveSwitch}
        />}
      
      {showFrenchTranslation && <>
        <div style={{ marginTop: '10px' }}>
          <StyledComponents.StyledCustomEditorLabel>{t('featureRelease.frenchDetailedDesc')}</StyledComponents.StyledCustomEditorLabel>
          <CustomEditor
            value={get(sideSheetData, 'bodyLocale.frCA', '')}
            onChange={onLongDescChangefrCA} readOnlyMode={archiveSwitch}>
          </CustomEditor>
          <StyledComponents.StyledLongDescCount>
            <StyledComponents.StyledCountLabel>
              {get(sideSheetData, 'bodyLocale.frCA', '').length}/4750
            </StyledComponents.StyledCountLabel>
          </StyledComponents.StyledLongDescCount>
        </div>
        <div style={{ marginTop: '10px' }}>
        <StyledComponents.StyledTextAreaWithCustomHeight
          customHeight="60px"
          dataTestId={`learn-more-input-frCA`}
          errorMessage="Error message"
          id={`learn-more-name-input-fr`}
          inputDivider="left"
          label={t('featureRelease.learnMoreFrCA')}
          name="learnMore-frCA"
          onChange={onLearnMoreChange}
          placeholder={`Eg. https://connectcdk.com/`}
          value={get(sideSheetData, 'linkToLearnMoreLocale.frCA', '')}
          maxLength={200}
          isDisabled={archiveSwitch}
        />
      </div></>}
      <MultiSelectDropdownMenu
        options={applicationOptions || []}
        name="targetApplications"
        onSelect={onApplicationSelect}
        value={get(sideSheetData, 'targetApplications', '')}
        label={t('featureRelease.targetApplications')}
        placeholder={t('featureRelease.selectApplications')}
        isDisabled={archiveSwitch}
      ></MultiSelectDropdownMenu>
      <MultiSelectDropdownMenu
        options={workflowOptions || []}
        name="targetWorkflows"
        onSelect={onWorkflowSelect}
        value={get(sideSheetData, 'targetWorkflows', '')}
        label={t('featureRelease.targetWorkflows')}
        placeholder={t('featureRelease.selectWorkflows')}
        isDisabled={archiveSwitch}
      ></MultiSelectDropdownMenu>

      <MultiSelectDropdownMenu
        options={departmentOptions}
        name="targetDepartments"
        onSelect={onDepartmentSelect}
        value={get(sideSheetData, 'targetDepartments', [])}
        label={t('featureRelease.targetDepartments')}
        placeholder={t('featureRelease.selectDepartments')}
        isDisabled={archiveSwitch}
      ></MultiSelectDropdownMenu>

      <StyledComponents.StyledTargetSelectorContainer>
        <RadioGroup
          dataTestId="radio-group"
          id="radio-group-contact-method"
          label=""
          labelPosition="after"
          name="contact-method"
          onChange={(e: any) => includeExcludeTargets(e)}
          options={[
            { ariaLabel: 'include', id: 'radio-contact-method-option-1', label: t('featureRelease.include'), value: 'include' },
            { ariaLabel: 'exclude', id: 'radio-contact-method-option-2', label: t('featureRelease.exclude'), value: 'exclude' }
          ]}
          radioSize="standard"
          value={get(sideSheetData, "includeTargets", true) ? "include" : "exclude"}
        />
        <StyledComponents.StyledTabs
          activeItemIndex={activeItemIndex}
          alignment="left"
          items={tabs}
          onActiveItemChange={setActiveItemIndex}
          tabsLabel=""
        />
      </StyledComponents.StyledTargetSelectorContainer>
      <>
        <div
          style={{
            marginTop: '10px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ width: '180px' }}>
            <StyledWrapperDatePicker dayPickerLeft="0px" maxWidth="180px">
              <DatePicker
                dataTestId="start-date-picker"
                date={get(sideSheetData, 'startDate', null)}
                dateFormat="MM/DD/YYYY"
                dateInputProps={{
                  enableCustomValidation: true,
                  errorMessage: t('featureRelease.fieldErrorStartDate'),
                  hasError: showStartDateValidation,
                  isReadOnly: false,
                  isRequired: true,
                  isDisabled: archiveSwitch,
                  size: 'standard',
                  onError: () => { },
                }}
                id="start-date-picker"
                label={t('featureRelease.startDate')}
                maximumYear={2100}
                minimumYear={1900}
                name="start-date-picker"
                numberOfMonths={1}
                onDateChange={onStartDateChange}
                shortcutChipsPosition="none"
                highlightToday
              />
            </StyledWrapperDatePicker>
          </div>

          <div style={{ width: '180px' }}>
            <StyledWrapperDatePicker dayPickerLeft="-132px" maxWidth="180px">
              <DatePicker
                className="endDatePicker"
                dataTestId="end-date-picker"
                date={get(sideSheetData, 'endDate', null)}
                dateFormat="MM/DD/YYYY"
                dateInputProps={{
                  enableCustomValidation: true,
                  errorMessage: t('featureRelease.fieldErrorEndDate'),
                  hasError: showEndDateValidation,
                  isReadOnly: false,
                  isRequired: true,
                  isDisabled: archiveSwitch,
                  size: 'standard',
                  onError: () => {},
                }}
                id="end-date-picker"
                label={t('featureRelease.endDate')}
                maximumYear={2100}
                minimumYear={1900}
                name="end-date-picker"
                numberOfMonths={1}
                onDateChange={onEndDateChange}
                shortcutChipsPosition="none"
                
              />
            </StyledWrapperDatePicker>
          </div>
        </div>

        <div
          style={{
            marginTop: '10px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ width: '180px' }}>
            <TimeField
              icon={<IconSchedule />}
              handleChange={onStartTimeChange}
              value={get(sideSheetData, 'startTime', '')}
              name={'startTime'}
              label={t('featureRelease.startTime')}
              isDisabled={archiveSwitch}
              isRequired={true}
            />
          </div>
          <div style={{ width: '180px' }}>
            <TimeField
              handleChange={onEndTimeChange}
              value={get(sideSheetData, 'endTime', '')}
              name={'endTime'}
              label={t('featureRelease.endTime')}
              isDisabled={archiveSwitch}
              isRequired={true}
            />
          </div>
        </div>
      </>

      <div style={{ marginTop: '10px' }}>
        <StyledComponents.StyledTextAreaWithCustomHeight
          customHeight="60px"
          dataTestId={`learn-more-input-enUS`}
          errorMessage="Error message"
          id={`learn-more-name-input-enUS`}
          inputDivider="left"
          label={t('featureRelease.learnMore')}
          name="learnMore-enUS"
          onChange={onLearnMoreChange}
          placeholder={`Eg. https://connectcdk.com/`}
          value={get(sideSheetData, 'linkToLearnMore', '')}
          maxLength={200}
          isDisabled={archiveSwitch}
        />
      </div>
      <ActionButtonContainer
        position="sticky"
        zIndex="999"
        positionProps={{ bottom: '0px' }}
        background={
          darkMode
            ? 'linear-gradient(black, transparent)'
            : 'linear-gradient(white, transparent)'
        }
      >
        <div>

          <StyledComponents.StyledTextButton
            dataTestId="text-button"
            iconColor="primary"
            onClick={handleCancel}
            text={t('featureRelease.cancel')}
          />


          { 
              sideSheetData.messageId && !archiveSwitch && (
                <PrimaryButton
                  dataTestId="save-side-sheet-button"
                  iconColor="primary"
                  onClick={handleUpdate}
                  text={t('featureRelease.update')}
                  isDisabled={updateMutation.isLoading}
                />
              )}

            {!sideSheetData.messageId && (
              <PrimaryButton
                dataTestId="save-side-sheet-button"
                iconColor="primary"
                onClick={handleSave}
                text={t('featureRelease.save')}
                isDisabled={createMutation.isLoading}
              />
            )}
            
        </div>
      </ActionButtonContainer>
    </div>
  );
};
